import { StandardEvents } from '@shopify/events';

// Keep native Horizon commerce events; enhance only the custom navigation.
function init243Navigation() {
  const menu = document.querySelector('.c243-mobile-menu');
  if (!menu || menu.dataset.enhanced) return;
  menu.dataset.enhanced = 'true';
  const summary = menu.querySelector('summary');
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape' && menu.open) { menu.open = false; summary.focus(); }
  });
  document.addEventListener('click', event => { if (menu.open && !menu.contains(event.target)) menu.open = false; });
  menu.addEventListener('click', event => { if (event.target.closest('a')) menu.open = false; });
  window.matchMedia('(min-width: 850px)').addEventListener('change', event => { if (event.matches) menu.open = false; });
}
init243Navigation();
document.addEventListener('shopify:section:load', init243Navigation);
document.addEventListener(StandardEvents.cartLinesUpdate, event => {
  event.promise?.then(({ cart }) => {
    const quantity = cart?.totalQuantity;
    if (typeof quantity !== 'number') return;
    for (const counter of document.querySelectorAll('[data-c243-cart-count]')) {
      counter.textContent = `(${quantity})`;
      counter.closest('a')?.setAttribute('aria-label', `Shopping bag, ${quantity} items`);
    }
  }).catch(error => {
    if (error?.name !== 'AbortError') console.warn('[243] Bag count update unavailable.');
  });
});
